import script from "./ReferenceThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceThumbnail.vue?vue&type=style&index=0&id=24826fb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24826fb0"]])

export default __exports__